// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   BACKGROUND (DEEP GRADIENT)
========================= */
.app-container {
  height: 100vh;
  width: 100%;
  background: radial-gradient(circle at 20% 20%, #132b4d, #0a1628 45%, #050b16 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', 'Segoe UI', sans-serif;
}

/* =========================
   FLOATING GLOW BLOBS
========================= */
.overlay::before,
.overlay::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.6;
}

.overlay::before {
  width: 400px;
  height: 400px;
  background: rgba(198, 161, 91, 0.35);
  top: 10%;
  left: 15%;
  animation: float1 10s infinite ease-in-out;
}

.overlay::after {
  width: 350px;
  height: 350px;
  background: rgba(47, 111, 94, 0.35);
  bottom: 10%;
  right: 15%;
  animation: float2 12s infinite ease-in-out;
}

/* =========================
   GLASS CARD (PREMIUM)
========================= */
.content-card {
  position: relative;
  z-index: 2;
  backdrop-filter: blur(25px);
  background: rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  padding: 60px 50px;
  text-align: center;
  box-shadow:
    0 25px 80px rgba(0,0,0,0.5),
    inset 0 0 1px rgba(255,255,255,0.2);
  animation: fadeIn 1s ease;
  transition: transform 0.4s ease;
}

.content-card:hover {
  transform: translateY(-6px) scale(1.01);
}

/* =========================
   LOGO WRAPPER (BRANDING 🔥)
========================= */
.logo-wrapper {
  padding: 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #c6a15b, #e3c98a);
  display: inline-block;
  margin-bottom: 20px;
  box-shadow: 0 0 25px rgba(198, 161, 91, 0.4);
}

/* LOGO */
.app-logo {
  width: 90px;
  height: auto;
  object-fit: contain;
  animation: pop 0.8s ease;
  filter: drop-shadow(0 0 10px rgba(198, 161, 91, 0.5));
}

/* =========================
   TITLE + TEXT
========================= */
.title {
  font-family: 'Fraunces', Georgia, serif;
  font-size: 38px;
  font-weight: 600;
  color: #fbf9f4;
  letter-spacing: 1px;
  margin: 10px 0 5px;
}

.subtitle {
  font-size: 16px;
  color: #cbd5e1;
  margin-bottom: 35px;
}

/* =========================
   BUTTON (PREMIUM CTA)
========================= */
.admin-btn {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 40px;
  background: linear-gradient(135deg, #c6a15b, #a8823f);
  color: #0a1628;
  text-decoration: none;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(198, 161, 91, 0.4);
}

.admin-btn:hover {
  background: linear-gradient(135deg, #e3c98a, #c6a15b);
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 12px 35px rgba(198, 161, 91, 0.6);
}

/* =========================
   ANIMATIONS
========================= */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pop {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes float1 {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-40px); }
}

@keyframes float2 {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(40px); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,aAAa;EACb,WAAW;EACX,kFAAkF;EAClF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;2BAE2B;AAC3B;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,UAAU;EACV,0CAA0C;AAC5C;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;;uCAEqC;EACrC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;;2BAE2B;AAC3B;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;2BAE2B;AAC3B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;;2BAE2B;AAC3B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC","sourcesContent":["/* =========================\n   BACKGROUND (DEEP GRADIENT)\n========================= */\n.app-container {\n  height: 100vh;\n  width: 100%;\n  background: radial-gradient(circle at 20% 20%, #132b4d, #0a1628 45%, #050b16 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n}\n\n/* =========================\n   FLOATING GLOW BLOBS\n========================= */\n.overlay::before,\n.overlay::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(120px);\n  opacity: 0.6;\n}\n\n.overlay::before {\n  width: 400px;\n  height: 400px;\n  background: rgba(198, 161, 91, 0.35);\n  top: 10%;\n  left: 15%;\n  animation: float1 10s infinite ease-in-out;\n}\n\n.overlay::after {\n  width: 350px;\n  height: 350px;\n  background: rgba(47, 111, 94, 0.35);\n  bottom: 10%;\n  right: 15%;\n  animation: float2 12s infinite ease-in-out;\n}\n\n/* =========================\n   GLASS CARD (PREMIUM)\n========================= */\n.content-card {\n  position: relative;\n  z-index: 2;\n  backdrop-filter: blur(25px);\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 24px;\n  padding: 60px 50px;\n  text-align: center;\n  box-shadow:\n    0 25px 80px rgba(0,0,0,0.5),\n    inset 0 0 1px rgba(255,255,255,0.2);\n  animation: fadeIn 1s ease;\n  transition: transform 0.4s ease;\n}\n\n.content-card:hover {\n  transform: translateY(-6px) scale(1.01);\n}\n\n/* =========================\n   LOGO WRAPPER (BRANDING 🔥)\n========================= */\n.logo-wrapper {\n  padding: 12px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #c6a15b, #e3c98a);\n  display: inline-block;\n  margin-bottom: 20px;\n  box-shadow: 0 0 25px rgba(198, 161, 91, 0.4);\n}\n\n/* LOGO */\n.app-logo {\n  width: 90px;\n  height: auto;\n  object-fit: contain;\n  animation: pop 0.8s ease;\n  filter: drop-shadow(0 0 10px rgba(198, 161, 91, 0.5));\n}\n\n/* =========================\n   TITLE + TEXT\n========================= */\n.title {\n  font-family: 'Fraunces', Georgia, serif;\n  font-size: 38px;\n  font-weight: 600;\n  color: #fbf9f4;\n  letter-spacing: 1px;\n  margin: 10px 0 5px;\n}\n\n.subtitle {\n  font-size: 16px;\n  color: #cbd5e1;\n  margin-bottom: 35px;\n}\n\n/* =========================\n   BUTTON (PREMIUM CTA)\n========================= */\n.admin-btn {\n  display: inline-block;\n  padding: 14px 32px;\n  border-radius: 40px;\n  background: linear-gradient(135deg, #c6a15b, #a8823f);\n  color: #0a1628;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 15px;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 25px rgba(198, 161, 91, 0.4);\n}\n\n.admin-btn:hover {\n  background: linear-gradient(135deg, #e3c98a, #c6a15b);\n  transform: translateY(-3px) scale(1.03);\n  box-shadow: 0 12px 35px rgba(198, 161, 91, 0.6);\n}\n\n/* =========================\n   ANIMATIONS\n========================= */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pop {\n  from {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes float1 {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-40px); }\n}\n\n@keyframes float2 {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(40px); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
